/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyExternalOrderItem from './pharmacy-external-order-item';
import PharmacyExternalOrderItemDetail from './pharmacy-external-order-item-detail';
import PharmacyExternalOrderItemUpdate from './pharmacy-external-order-item-update';
import PharmacyExternalOrderItemDeleteDialog from './pharmacy-external-order-item-delete-dialog';

const PharmacyExternalOrderItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyExternalOrderItem />} />
    <Route path="new" element={<PharmacyExternalOrderItemUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyExternalOrderItemDetail />} />
      <Route path="edit" element={<PharmacyExternalOrderItemUpdate />} />
      <Route path="delete" element={<PharmacyExternalOrderItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyExternalOrderItemRoutes;
